import { FC } from 'react';

import { AuthMainUi } from '../../components/AuthMainUi';
import { CreatePasswordForm } from './components/CreatePasswordForm';

export const CreatePasswordPage: FC = (): JSX.Element => {
  return (
    <AuthMainUi>
      <CreatePasswordForm />
    </AuthMainUi>
  );
};
